import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import { Card, CardBody, Col, Row } from "reactstrap"
import { Pagination } from "antd"
import { Link } from "react-router-dom"
import SearchBrandRule from './filter/SearchBrandRule'
import FilterUpdateAt from './filter/FilterUpdateAt'
import FilterSelect from './filter/FilterSelect'
import BrandsRuleTable from './table/BrandsRuleTable'
import { getExportBrandsRule, getListBrandRule } from '../../../services/api/apiBrands'
import UseDebounce from './helpers/UseDebounce'
import moment from 'moment'
import {createJobExport} from '../../helpers/createJobExport'
import downloadFileFromData from '../../helpers/downloadFileFromData'
import { canViewStoreName } from '../../../services/StorageServices'

const STATUS = [
    {
        name: 'Active',
        value: 'active'
    },
    {
        name: 'Deactive',
        value: 'deactive'
    }
]

const BRAND_TYPE = [
    {
        name: 'Branding',
        value: 'branding'
    },
    {
        name: 'Packaging',
        value: 'packaging'
    }
]


const BrandsRulePage = () => {
    const canViewStore = canViewStoreName()

    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [error, setError] = useState('')
    const [typeBrand, setTypeBrand] = useState('')
    const [status, setStatus] = useState('')
    const [updateAt, setUpdateAt] = useState('')
    const [fieldSearch, setFieldSearch] = useState(canViewStore ? 'store' : 'brand_name')
    const [valueSearch, setValueSearch] = useState('')
    const [listBrandsRule, setListBrandsRule] = useState([])

    const deBounceValueSearch = valueSearch === '' ? UseDebounce(valueSearch, 0) : UseDebounce(valueSearch, 500)

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleChangeDate = filter => {
        setUpdateAt({ ...filter })
        setPage(1)
    }

    const _handleChangeFieldSeach = field => {
        setFieldSearch(field)
        setValueSearch('')
    }

    const _hanldeChangeValueSearch = value => {
        setValueSearch(value)
        setPage(1)
    }

    const _handleChangeBrandType = typeBrand => {
        setTypeBrand(typeBrand)
        setPage(1)
    }

    const _handleChangeStatus = status => {
        setStatus(status)
        setPage(1)
    }

    const _fetchListBrandRule = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page,
                limit
            }
            const query = {
                brand_type: "",
                store: "",
                brand_name: "",
                product_type: "",
                order_tag: "",
                update_at: {
                    from: "",
                    to: ""
                }
            }

            if (typeBrand) query.brand_type = typeBrand
            if (status) {
                if (status === 'active') query.status = true
                if (status === 'deactive') query.status = false
            }
            if (updateAt.update_at) query.update_at = updateAt.update_at
            if (valueSearch) {
                if (fieldSearch === 'store') query.store = valueSearch
                if (fieldSearch === 'brand_name') query.brand_name = valueSearch
                if (fieldSearch === 'product_type') query.product_type = valueSearch
                if (fieldSearch === 'tag') query.order_tag = valueSearch
            }

            if (Object.keys(query).length > 0) payload.query = query

            const { data } = await getListBrandRule(payload)
            const { success, message, data: res } = data

            if (!success) return setError(message)

            const { brand_rule, total } = res

            setListBrandsRule(brand_rule)
            setTotal(total)


        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleExportBrandsRule = async() => {
        try {
            const payload = {
                page,
                limit
            }
            const query = {
                brand_type: "",
                store: "",
                brand_name: "",
                product_type: "",
                order_tag: "",
                update_at: {
                    from: "",
                    to: ""
                }
            }

            if (typeBrand) query.brand_type = typeBrand
            if (status) {
                if (status === 'active') query.status = true
                if (status === 'deactive') query.status = false
            }
            if (updateAt.update_at) query.update_at = updateAt.update_at
            if (valueSearch) {
                if (fieldSearch === 'store') query.store = valueSearch
                if (fieldSearch === 'brand_name') query.brand_name = valueSearch
                if (fieldSearch === 'product_type') query.product_type = valueSearch
                if (fieldSearch === 'tag') query.order_tag = valueSearch
            }

            if (Object.keys(query).length > 0) payload.query = query

            const {data: res} = await getExportBrandsRule(payload)
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)
                if (Object.keys(data).length > 0) createJobExport(data)
            } else {
                downloadFileFromData(res, { filename: `BrandsRule-${moment().format('YYYY-MM-DD')}.csv` })
            }
        } catch (e) {
            alert(e.toString())
        }

    }

    useEffect(() => {
        _fetchListBrandRule()
    }, [limit, page, typeBrand, status, updateAt, deBounceValueSearch])

    if (error) return <span className='text-danger'>{error}</span>

    return (
        <div className='BrandsRulePage'>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Brands Rule Management</h1>
                        <div className="actions">
                            <button
                                className='btn btn-outline-primary mr-2'
                                onClick={handleExportBrandsRule}
                            >
                                Export
                            </button>
                            <Link to='/brands' className="btn btn-link">Brands Management</Link>
                            <Link to='/tag-brands' className="btn btn-link">Tag Brands Inventory</Link>
                            <Link to='/brands-rule/create' className="btn btn-primary">Add brands rule</Link>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="BrandsRuleFilters mb-3 p-3">
                        <Row form>
                            <Col lg={4} className="mr-2">
                                <SearchBrandRule
                                    handleChangeFieldSeach={_handleChangeFieldSeach}
                                    hanldeChangeValueSearch={_hanldeChangeValueSearch}
                                    valueSearch={valueSearch}
                                    fieldSearch={fieldSearch}
                                    placeholders={{
                                        store: "store",
                                        brand_name: "brand name",
                                        product_type: "product type",
                                        tag: "tag"
                                    }}
                                />
                            </Col>
                            <Col lg={2} className="mr-2">
                                <FilterSelect
                                    options={BRAND_TYPE}
                                    placeholder="-- Brand type"
                                    onChangeSelect={_handleChangeBrandType}
                                />
                            </Col>
                            <Col lg={2} className="mr-2">
                                <FilterSelect
                                    options={STATUS}
                                    placeholder="-- Status"
                                    onChangeSelect={_handleChangeStatus}
                                />
                            </Col>
                            <Col lg={2} className="mr-2">
                                <FilterUpdateAt
                                    handleChangeDate={_handleChangeDate}
                                    updated={updateAt}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='d-flex align-items-center ml-3'>
                                <div className='ml-3'>Total: <span className='font-weight-bold'>{total || 0}</span></div>
                            </div>
                        </div>
                    </div>

                    <BrandsRuleTable
                        listBrandsRule={listBrandsRule}
                        loading={loading}
                        error={error}
                    />

                    <Pagination
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        className='text-right mt-3'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />

                </CardBody>
            </Card>
        </div>
    )
}

export default BrandsRulePage